<template>
    <div
        v-if="images"
        class="m-gallery"
        :class="{'m-gallery--singlePhoto': images.length === 1}"
    >
        <div
            v-for="(image, imageIdx) in images"
            :key="imageIdx"
            @click="showImage(imageIdx)"
        >
            <a-image
                class="m-gallery__image"
                :src="image.full_path ? image.full_path : image"
            />
        </div>
        <o-modal name="gallery">
            <p v-if="images.length > 1">{{ currentImage + 1 }} / {{ images.length }}</p>
            <a-image
                v-if="images[currentImage]"
                class="m-gallery__fullImage"
                :src="images[currentImage].full_path ? images[currentImage].full_path : images[currentImage]"
                :modal="true"
            />
            <div
                v-if="images.length > 1"
                class="m-gallery__nav"
            >
                <a-button
                    @click="currentImage < 1 ? currentImage = images.length - 1 : currentImage--"
                >
                    Poprzednie
                </a-button>
                <a-button
                    @click="currentImage >= images.length - 1 ? currentImage = 0 : currentImage++"
                >
                    Następne
                </a-button>
            </div>
        </o-modal>
    </div>
</template>

<script>
export default {
    data() {
        return {
            currentImage: 0
        }
    },
    props: {
        images: {
            type: Array,
            required: true
        }
    },
    methods: {
        showImage(imageIdx) {
            this.currentImage = imageIdx
            this.$store.dispatch('modalShow', 'gallery')
        }
    }
}
</script>
